export function mark(name: string): void {
  if (typeof performance !== "undefined" && typeof performance.mark === "function") {
    performance.mark(name);
  }
}

export function measure(name: string, startMark: string, endMark: string): void {
  if (typeof performance !== "undefined" && typeof performance.measure === "function") {
    performance.measure(name, startMark, endMark);
  }
}
